<div class="page-body">
    <h1 data-aos="fade-down" data-aos-duration="800">Paper: A Light Installation</h1>
    <div class="info">
        <p><strong>Context</strong><br>A passion project</p>
        <p><strong>Themes</strong><br>Education, Tangible design, Sustainability</p>
        <p><strong>Materials</strong><br>Recycled Paper, LED light system</p>
    </div>
    <!-- <h2>Engaging with the history of paper.</h2> -->
    <p>This LED-powered light installation takes the viewer through the history of paper through a connected length of paper cut designs.
         The series of depicted events, from its ancient origins in China to the crusades, the paper mills, and modern usages are carved along a spiral
          representing the tree's age rings. </p>
    <img class="full-screen" src="assets/fun/paper1.jpg">

    <p>The entirety of its paper construction is from recycled paper. The sides of the installation imitate the bark of a tree and was constructed 
        with a collage technique. The LED fixture was chosen to minimize energy consumption and provide another way the viewer can interact with the
         piece. The lights are connected to a remote that changes the light dimness and color to the user's preference. </p>
    <img class="process" src="assets/fun/paper2.jpg">

    <a class="next" routerLink="/shadowPuppetry">Next work -></a>
</div>

